import React from 'react'
import { Grid, Typography } from '@mui/material'
import Project from './Project'

const Projects = ({ resumeData }) => {

  return (
    <section id="projects" class='section'>
        <div className="projects-container">
            <Typography mb={4} variant="h4" align="center" gutterBottom>
                Check out some of my projects
            </Typography>
            <Grid container columnSpacing={2} rowSpacing={3} alignItems="stretch">
            {
            resumeData.portfolio && resumeData.portfolio.map((item, index)=>{
                return(
                <Grid item xs={12} sm={6} md={4} key={item.name || index} sx={{ display: 'flex' }}>
                    <Project data={item}/>
                </Grid>
                )
            })
            }

            </Grid>
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
            
            </div>
        </div>
    </section>
  )
}

export default Projects
